var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 200,
    viewBox: "0 0 222 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.42 4.15H11.21V192.42H211.42V4.15Z",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.16 191.77H3.22998V198.5H219.16V191.77Z",
    fill: "#E8E7E7",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.93 95.52H24.22V172.69H157.93V95.52Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.59 99.8H28.5598V168.4H153.59V99.8Z",
    fill: "#83BED7",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1807_47750)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M108.081 88.3463L62.9221 181.719L85.5002 192.639L130.659 99.2658L108.081 88.3463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M89.9707 88.3413L44.8123 181.715L56.9925 187.605L102.151 94.2321L89.9707 88.3413Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.64 100.47H163.92V187.45H199.64V100.47Z",
    fill: "#83BED7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1807_47750)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M216.305 94.8807L171.146 188.254L193.724 199.173L238.883 105.8L216.305 94.8807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M198.201 94.8747L153.042 188.248L165.223 194.139L210.381 100.766L198.201 94.8747Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.64 95.52H163.93V187.45H199.64V95.52Z",
    stroke: "#8B95A7",
    strokeWidth: 2.78,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.84 149.75H163.93V156.32H198.84V149.75Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8099 90.29H26.6099L43.5799 74.72H62.9299L50.8099 90.29Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6099 90.29H2.3999L24.2199 74.72H43.5799L26.6099 90.29Z",
    fill: "#F37221",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.21 90.29H75.01L82.29 74.72H101.64L99.21 90.29Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0098 90.29H50.8098L62.9298 74.72H82.2898L75.0098 90.29Z",
    fill: "#F37221",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.62 90.29H123.42L120.99 74.72H140.35L147.62 90.29Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.42 90.29H99.21L101.64 74.72H120.99L123.42 90.29Z",
    fill: "#F37221",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.83 90.29H147.62L140.35 74.72H159.71L171.83 90.29Z",
    fill: "#F37221",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.03 90.29H171.83L159.71 74.72H179.06L196.03 90.29Z",
    fill: "white",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M220.23 90.29H196.03L179.06 74.72H198.41L220.23 90.29Z",
    fill: "#F37221",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6099 90.29H50.8099V99.22C50.8099 105.9 45.3899 111.32 38.7099 111.32C32.0299 111.32 26.6099 105.9 26.6099 99.22V90.29V90.29Z",
    fill: "#DBF0EF",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 90.29H26.6099V99.22C26.6099 105.9 21.1899 111.32 14.5099 111.32C7.8299 111.32 2.4099 105.9 2.4099 99.22V90.29H2.3999Z",
    fill: "#E45325",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.11 111.32C80.43 111.32 75.01 105.9 75.01 99.22V90.29H99.21V99.22C99.21 105.9 93.79 111.32 87.11 111.32V111.32Z",
    fill: "#DBF0EF",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9098 111.32C56.2298 111.32 50.8098 105.9 50.8098 99.22V90.29H75.0098V99.22C75.0098 105.9 69.5898 111.32 62.9098 111.32V111.32Z",
    fill: "#E45325",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.52 111.32C128.84 111.32 123.42 105.9 123.42 99.22V90.29H147.62V99.22C147.62 105.9 142.2 111.32 135.52 111.32Z",
    fill: "#DBF0EF",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.32 111.32C104.64 111.32 99.22 105.9 99.22 99.22V90.29H123.42V99.22C123.42 105.9 118 111.32 111.32 111.32V111.32Z",
    fill: "#E45325",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.72 111.32C153.04 111.32 147.62 105.9 147.62 99.22V90.29H171.82V99.22C171.82 105.9 166.4 111.32 159.72 111.32Z",
    fill: "#E45325",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.93 111.32C177.25 111.32 171.83 105.9 171.83 99.22V90.29H196.03V99.22C196.03 105.9 190.61 111.32 183.93 111.32Z",
    fill: "#DBF0EF",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M208.13 111.32C201.45 111.32 196.03 105.9 196.03 99.22V90.29H220.23V99.22C220.23 105.9 214.81 111.32 208.13 111.32Z",
    fill: "#E45325",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.98 2.4H8.6499V6.99H213.98V2.4Z",
    fill: "#E8E7E7",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M205.33 187.46H157.16V191.77H205.33V187.46Z",
    fill: "#CFD0D0",
    stroke: "#8B95A7",
    strokeWidth: 2.81,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.38 152.47H168.09V153.73H174.38V152.47Z",
    fill: "#8B95A7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.64 23.57H28.6599V57.87H192.64V23.57Z",
    fill: "#83BED7",
    stroke: "#8B95A7",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1807_47750)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M140.508 13.1738L95.3499 106.547L117.928 117.466L163.086 24.0933L140.508 13.1738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M122.408 13.1688L77.25 106.542L89.4303 112.433L134.589 19.0596L122.408 13.1688Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.2 19.29H24.3298V62.17H197.2V19.29Z",
    stroke: "#8B95A7",
    strokeWidth: 2.38,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1807_47750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 79,
    fill: "white",
    transform: "translate(45 88)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1807_47750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 91,
    fill: "white",
    transform: "translate(153 95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1807_47750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    fill: "white",
    transform: "translate(77 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/Shop.1e2398c1474e091d6631de249b5b374f.svg";
export { ForwardRef as ReactComponent };